import SearchDialog from './SearchDialog';

export default SearchDialog;
